import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Modal } from 'common/components/layout';
import CreditCardDisplay from 'profile/creditCard/CreditCardDisplay';
import { editClubMembership } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';

import { activeClubMembershipsWithoutThisCreditCard } from '../helpers';

class ClubMembershipCreditCardVerify extends Component {
  constructor(props) {
    super(props);
    const potentialMemberships = activeClubMembershipsWithoutThisCreditCard(
      props.creditCardId,
      props.activeClubMemberships
    );
    if (potentialMemberships.length === 1) {
      this.state = {
        [potentialMemberships[0].id]: true
      };
    } else {
      const object = {};
      potentialMemberships.forEach((membership) => {
        object[membership.id] = false;
      });
      this.state = object;
    }
  }

  handleSubmit = () => {
    const { props, state } = this;
    const clubMembershipArrayIds = Object.keys(state);
    const changedIds = clubMembershipArrayIds.filter(
      (cmId) => state[cmId] === true
    );
    changedIds.forEach((id) => {
      const data = {
        customerCreditCardId: props.creditCardId
      };
      props.editClubMembership(id, data);
    });
    props.onCloseModal();
  };

  handleCancel = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  render() {
    const { creditCardId, customerCreditCards, activeClubMemberships } =
      this.props;
    const { onCloseModal } = this.props;
    const { state } = this;
    const creditCard = customerCreditCards.data[creditCardId];
    const potentialMemberships = activeClubMembershipsWithoutThisCreditCard(
      creditCardId,
      activeClubMemberships
    );
    const isOneOneArray = Object.keys(this.state);

    const isOneOne = isOneOneArray.find(
      (clubMembershipId) => state[clubMembershipId] === true
    );
    return (
      <Modal
        title="Add Credit Card to Club Membership"
        onCloseModal={onCloseModal}
      >
        {potentialMemberships.length === 1 && (
          <p>
            Would you like to make this credit card your credit card for{' '}
            {potentialMemberships[0].club.title}
          </p>
        )}
        {potentialMemberships.length > 1 && (
          <>
            <p>
              Would you like to make this credit card your credit card for
              following clubs:
            </p>
            <p>
              {potentialMemberships.map((membership) => (
                <Fragment key={membership.id}>
                  <input
                    type="checkbox"
                    name={membership.id}
                    checked={state[membership.id]}
                    onChange={this.handleChange}
                    id={membership.id}
                  />{' '}
                  <label htmlFor={membership.id}>{membership.club.title}</label>
                  <br />
                </Fragment>
              ))}
            </p>
          </>
        )}
        <CreditCardDisplay creditCard={creditCard} boldName />
        <br />
        <br />
        <div className="c7-form__button-row">
          <a
            onClick={this.handleCancel}
            onKeyPress={this.handleKeyPress}
            role="link"
            tabIndex={0}
            className="c7-button-alt"
          >
            No
          </a>
          {isOneOne && (
            <button
              type="submit"
              onClick={this.handleSubmit}
              className="c7-button"
            >
              Yes
            </button>
          )}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  activeClubMemberships: getActiveClubMemberships(state.clubMembership),
  settings: state.setting,
  customerCreditCards: state.customerCreditCard
});

ClubMembershipCreditCardVerify = reduxForm({
  form: 'ClubMembershipCreditCardVerify',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  }
})(ClubMembershipCreditCardVerify);

export default connect(mapStateToProps, {
  editClubMembership
})(ClubMembershipCreditCardVerify);
